
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftBottom100 as ObiThreewayStackedInleftBottom100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-bottom-100.js';
 
 
 

 
 export const ObiThreewayStackedInleftBottom100 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-bottom-100',
   elementClass: ObiThreewayStackedInleftBottom100Element,
   events: {
     
   }
  });
 
 